import UniversityTargets from "./components/UniversityTargets";

export default UniversityTargets;
